module.exports = __webpack_public_path__ + "media/luxury-2026/coastal-kitchen-79667faa.jpg";